import { ReactRenderer } from './lib/ReactRenderer';
import FetchHelper from "./lib/fetchHelper.js";
import MemberDialog from './lib/memberDialog';
import React from 'react';
/**
 * "Frivillige" (boards Frivillige and Frivillige - bred skaerm): the volunteers with the e-mail they
 * share and the phone number to ring. A phone has a list under a bar for each letter; from 992px
 * the same rows are a table with the titles Navn, E-mail and Telefon.
 */
const ICON_PROPS = {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true
};
/** 28560934 as 28 56 09 34, the way the boards show a number. Anything else is shown as it is. */
const formatPhone = (phone) => {
    const digits = (phone !== null && phone !== void 0 ? phone : "").replace(/\s/g, "");
    return /^\d{8}$/.test(digits) ? digits.replace(/(\d{2})(?=\d)/g, "$1 ") : phone;
};
const MemberRow = ({ member, onOpen }) => {
    const phone = member.phoneNo ? formatPhone(member.phoneNo) : "";
    return (React.createElement("div", { className: "bi-ml-row" },
        React.createElement("button", { type: "button", className: "bi-ml-name bi-member-open", onClick: () => onOpen(member) }, member.name),
        React.createElement("span", { className: "bi-ml-email" }, member.showEmail && member.email
            ? React.createElement("a", { href: `mailto:${member.email}` }, member.email)
            : React.createElement("span", { className: "bi-ml-hidden" },
                React.createElement("svg", Object.assign({}, ICON_PROPS),
                    React.createElement("path", { d: "M3 3l18 18" }),
                    React.createElement("path", { d: "M10.6 6.2A9.5 9.5 0 0 1 12 6c5 0 8.5 4 9.5 6a13 13 0 0 1-2.6 3.4M6.4 7.6A13 13 0 0 0 2.5 12c1 2 4.5 6 9.5 6a9.3 9.3 0 0 0 3.6-.7" })),
                "E-mail skjult")),
        React.createElement("span", { className: "bi-ml-phone" }, phone
            ? React.createElement("a", { href: `tel:${member.phoneNo.replace(/\s/g, "")}`, "aria-label": `Ring til ${member.name} på ${phone}` },
                React.createElement("svg", Object.assign({}, ICON_PROPS),
                    React.createElement("path", { d: "M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a1 1 0 0 1-1 1A16 16 0 0 1 4 5a1 1 0 0 1 1-1z" })),
                phone)
            : null)));
};
export default class MemberListComponent extends React.Component {
    constructor(props) {
        super(props);
        this.load = () => {
            FetchHelper.get(`/bpapi/member`)
                .then((result) => {
                const members = [...result].sort((a, b) => { var _a, _b; return ((_a = a.name) !== null && _a !== void 0 ? _a : "").localeCompare((_b = b.name) !== null && _b !== void 0 ? _b : "", "da"); });
                this.setState({ isLoaded: true, members: members });
            })
                .catch(error => this.setState({ isLoaded: true, error: error }));
        };
        this.state = {
            isLoaded: false,
            query: ""
        };
    }
    componentDidMount() {
        this.load();
    }
    rows(members) {
        const rows = [];
        let last = "";
        members.forEach((member, idx) => {
            var _a, _b;
            const letter = ((_a = member.name) !== null && _a !== void 0 ? _a : "").charAt(0).toLocaleUpperCase("da");
            if (letter !== last) {
                rows.push(React.createElement("div", { className: "bi-ml-letter", key: `letter-${letter}` }, letter));
                last = letter;
            }
            rows.push(React.createElement(MemberRow, { key: `member-${(_b = member.key) !== null && _b !== void 0 ? _b : idx}`, member: member, onOpen: (m) => this.setState({ selectedMember: m }) }));
        });
        return rows;
    }
    render() {
        if (!this.state.isLoaded) {
            return (React.createElement("div", { className: "bp-loading" },
                React.createElement("i", { className: "fa fa-spinner fa-pulse fa-fw" })));
        }
        if (this.state.error) {
            return (React.createElement("p", { className: "card-text" }, this.state.error));
        }
        const query = this.state.query.trim().toLocaleLowerCase("da");
        const members = query
            ? this.state.members.filter((m) => { var _a; return ((_a = m.name) !== null && _a !== void 0 ? _a : "").toLocaleLowerCase("da").includes(query); })
            : this.state.members;
        return (React.createElement("div", { className: "bi-ml" },
            React.createElement("div", { className: "bi-ml-head" },
                React.createElement("h1", null, "Frivillige"),
                React.createElement("div", { className: "bi-ml-search" },
                    React.createElement("svg", Object.assign({}, ICON_PROPS, { strokeWidth: 1.75 }),
                        React.createElement("circle", { cx: "11", cy: "11", r: "7" }),
                        React.createElement("path", { d: "m20 20-3.5-3.5" })),
                    React.createElement("input", { type: "search", "aria-label": "S\u00F8g p\u00E5 navn", placeholder: "S\u00F8g p\u00E5 navn", value: this.state.query, onChange: (e) => this.setState({ query: e.target.value }) }))),
            React.createElement("div", { className: "bi-ml-list" },
                React.createElement("div", { className: "bi-ml-columns", "aria-hidden": "true" },
                    React.createElement("span", null, "Navn"),
                    React.createElement("span", null, "E-mail"),
                    React.createElement("span", null, "Telefon")),
                this.rows(members),
                members.length === 0 ? React.createElement("p", { className: "bi-ml-none" }, "Ingen frivillige matcher s\u00F8gningen.") : null),
            this.state.selectedMember
                ? React.createElement(MemberDialog, { name: this.state.selectedMember.name, phoneNo: this.state.selectedMember.phoneNo, pictureUrl: MemberDialog.photo(this.state.selectedMember.profilePictureUrl), onClose: () => this.setState({ selectedMember: null }) })
                : null));
    }
}
ReactRenderer.render("memberlistcomponent", (elem) => React.createElement(MemberListComponent, Object.assign({}, (elem.dataset))));
